import PropTypes from 'prop-types';
import { SegmentNew } from '@eti/types';
import {
  useBoundHeaderParameters,
  usetransformSegments,
} from '../cart/hooks/useCartTripDetailsSegment';
import ItineraryBoundHeader from './ItineraryBoundHeader';
import ItinerarySegment from './ItinerarySegment';
import ItineraryEventSegment from './ItineraryEventSegment';

const ItineraryBound = ({
  boundId,
  isMultiStop,
  isOpen,
  segments,
  shouldHideBaggageInfo,
  shouldShowTitle,
  type,
}) => {
  const boundHeaderParameters = useBoundHeaderParameters(isMultiStop, segments, type, boundId);
  const transformedSegments = usetransformSegments(segments);

  return (
    <>
      <ItineraryBoundHeader
        data-testid="tripDetails-header"
        shouldShowTitle={shouldShowTitle}
        {...boundHeaderParameters}
      />
      {transformedSegments?.map(({ hasNextStop, isTripSegment, segment, segmentId }) => {
        if (isTripSegment) {
          return (
            <ItinerarySegment
              key={`TripSegment-${segmentId}`}
              {...segment}
              hasNextStop={hasNextStop}
              shouldHideBaggageInfo={shouldHideBaggageInfo}
            />
          );
        }
        return (
          <ItineraryEventSegment isOpen={isOpen} key={`EventSegment-${segmentId}`} {...segment} />
        );
      })}
    </>
  );
};

ItineraryBound.propTypes = {
  boundId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isMultiStop: PropTypes.bool,
  isOpen: PropTypes.bool,
  segments: PropTypes.arrayOf(SegmentNew),
  shouldHideBaggageInfo: PropTypes.bool,
  shouldShowTitle: PropTypes.bool,
  type: PropTypes.string,
};

export default ItineraryBound;
